import {
  always,
  applySpec,
  compose,
  equals,
  find,
  map,
  path,
  pathOr,
  prop,
  includes,
} from "ramda";
import { DEFAULT_AVATAR_SOURCE, AVATAR_SIZE } from "../../constants/avatars";
import { FLAG_DELETED, FLAG_SPOILER, VOTE_LIKE } from "./constants";

const Guestbook = applySpec({
  guestbookKey: prop("guestbook_key"),
  totalComments: prop("total_comments"),
});

const mapUserAvatar = compose(
  pathOr(DEFAULT_AVATAR_SOURCE, ["source"]),
  find(compose(equals(`icon_${AVATAR_SIZE}`), prop("type"))),
  pathOr([], ["user", "user_attributes", "avatar", "unlocked"])
);

const Comment = applySpec({
  id: prop("comment_id"),
  guestbookKey: prop("guestbook_key"),
  parentCommentId: prop("parent_comment_id"),
  message: prop("message"),
  likesCount: pathOr(0, ["votes", "like"]),
  createdAt: prop("created"),
  modifiedAt: prop("modified"),
  authorUsername: path(["user", "user_attributes", "username"]),
  authorAvatar: mapUserAvatar,
  repliesCount: prop("replies_count"),
  flags: prop("flags"),
  isUserOwner: prop("is_owner"),
  locale: prop("locale"),
  userVotes: prop("user_votes"),
  isCommentDeleted: compose(includes(FLAG_DELETED), prop("flags")),
  isSpoilerHidden: compose(includes(FLAG_SPOILER), prop("flags")),
  isLiked: compose(includes(VOTE_LIKE), prop("user_votes")),
  isJustPosted: always(false),
  isCreateReplyError: always(false),
  isCreateReplyLoading: always(false),
  isDeletionInProgress: always(false),
  isTextareaVisible: always(false),
  isRepliesLoading: always(false),
});

const Comments = applySpec({
  total: prop("total"),
  items: compose(map(Comment), prop("items")),
});

export { Guestbook, Comments, Comment };
